import React, { useState, useEffect } from 'react';
import styles from './PasswordValidation.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

const PasswordValidation = ({ password, setValidPassword }) => {
    const [lengthValid, setLengthValid] = useState(false);
    const [threeOfFourValid, setThreeOfFourValid] = useState(false);
    const [criteriaMet, setCriteriaMet] = useState({
        upperCase: false,
        lowerCase: false,
        specialCharacter: false,
        number: false
    });

    const checkPasswordCriteria = (password) => {
        setLengthValid(password.length >= 8);

        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        // had to disable lint here to check for all characters, tried some approaches but lint is still throwing error
        // eslint-disable-next-line no-useless-escape
        const hasSpecialChar = /[!@#$%^&*()_+{}\[\]:;"'<>,.?~`|\\/-]/.test(password);
        const hasNumber = /\d/.test(password);

        setCriteriaMet({
            upperCase: hasUpperCase,
            lowerCase: hasLowerCase,
            specialCharacter: hasSpecialChar,
            number: hasNumber
        });

        const criteriaArray = [hasUpperCase, hasLowerCase, hasSpecialChar, hasNumber];
        const metCount = criteriaArray.filter(criteria => criteria).length;
        setThreeOfFourValid(metCount >= 3);
        if (metCount >= 3 && password.length >= 8) {
            setValidPassword(true);
        }
    };

    useEffect(() => {
        checkPasswordCriteria(password);
    }, [password]);

    return (
        <div id="password-checklist" className={styles.passwordChecklist}>
            <p className={styles.criteriaHeader}>Your password must meet these requirements:</p>
            <div className={styles.labelMargin}>
                <label style={lengthValid ? { color: '#007864' } : {}}>
                    {lengthValid ? (
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkboxMargin} />
                    ) : (
                        <FontAwesomeIcon icon={faCircle} className={styles.checkboxMargin} />
                    )}
                    Minimum of 8 characters
                </label><br />
            </div>
            <div className={styles.labelMargin}>

                <label style={threeOfFourValid ? { color: '#007864' } : {}}>
                    {threeOfFourValid ? (
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkboxMargin} />
                    ) : (
                        <FontAwesomeIcon icon={faCircle} className={styles.checkboxMargin} />)}
                    3 of 4 of the following:
                </label>
            </div>
            <div className={styles.criteriaList}>
                <div className={styles.labelMargin}>

                    <label style={criteriaMet.upperCase ? { color: '#007864' } : {}}>
                        {criteriaMet.upperCase ? (
                            <FontAwesomeIcon icon={faCheckCircle} className={styles.checkboxMargin} />
                        ) : (
                            <FontAwesomeIcon icon={faCircle} className={styles.checkboxMargin} />)}
                        At least 1 uppercase letter
                    </label><br />
                </div>
                <div className={styles.labelMargin}>

                    <label style={criteriaMet.lowerCase ? { color: '#007864' } : {}}>
                        {criteriaMet.lowerCase ? (
                            <FontAwesomeIcon icon={faCheckCircle} className={styles.checkboxMargin} />
                        ) : (
                            <FontAwesomeIcon icon={faCircle} className={styles.checkboxMargin} />)}
                        At least 1 lowercase letter
                    </label><br />
                </div>
                <div className={styles.labelMargin}>

                    <label style={criteriaMet.specialCharacter ? { color: '#007864' } : {}}>
                        {criteriaMet.specialCharacter ? (
                            <FontAwesomeIcon icon={faCheckCircle} className={styles.checkboxMargin} />
                        ) : (
                            <FontAwesomeIcon icon={faCircle} className={styles.checkboxMargin} />)}
                        At least 1 special character
                    </label><br />
                </div>
                <div className={styles.labelMargin}>

                    <label style={criteriaMet.number ? { color: '#007864' } : {}}>
                        {criteriaMet.number ? (
                            <FontAwesomeIcon icon={faCheckCircle} className={styles.checkboxMargin} />
                        ) : (
                            <FontAwesomeIcon icon={faCircle} className={styles.checkboxMargin} />
                        )}
                        At least 1 number
                    </label>
                </div>
            </div>


        </div>
    );
};

export default PasswordValidation;